export class LogoModel {
    name = '';
}